import { Box, styled } from '@mui/system'
import React from 'react'
import { useSelector } from 'react-redux'
import DepositItem from './DepositItem'
import DepositItemMarginRatio from './DepositItemMarginRatio'
import {
	selectDeltaEquity, selectShowCashBalance, selectUseMargin,
	selectUserAvailableMargin, selectUserBonusBalance, selectUserCashBalance,
	selectUserClosedTotalPnl, selectUserEquity, selectUserTotalPnl,
	selectShowClosedTotalPnl, selectShowAvailableMargin, selectShowTotalPnl,
	selectShowEquity, selectShowUsedMargin, selectShowEquityMarginRatio,
	selectShowBonusBalance, selectShowBalance, selectUserTotalBalance
	// selectUserDailyClosedPnl,
} from '../../../../store/redusers/user/selectors'


export const DepositBody = styled(Box)(({ theme, deposits }) => ({
	background: theme.palette.third,
	display: 'flex',
	justifyContent: deposits.length <= 4 ? 'flex-end' : 'space-around',
	overflow: 'auto',
	padding: '6px 15px',
	[theme.breakpoints.down('md')]: {
		justifyContent: 'space-between',
		padding: '4px 12px'
	}
}))

function Deposits() {
	const userClosedTotalPnl = useSelector(selectUserClosedTotalPnl)
	const userTotalPnl = useSelector(selectUserTotalPnl)
	const userCashBalance = useSelector(selectUserCashBalance)
	const userBonusBalance = useSelector(selectUserBonusBalance)
	const userTotalBalance = useSelector(selectUserTotalBalance)
	const deltaEquity = useSelector(selectDeltaEquity)
	const userEquity = useSelector(selectUserEquity)
	const useMargin = useSelector(selectUseMargin)
	const userAvailableMargin = useSelector(selectUserAvailableMargin)
	const showAvailableMargin = useSelector(selectShowAvailableMargin)
	const showCashBalance = useSelector(selectShowCashBalance)
	const showClosedTotalPnl = useSelector(selectShowClosedTotalPnl)
	const showTotalPnl = useSelector(selectShowTotalPnl)
	const showEquity = useSelector(selectShowEquity)
	const showUsedMargin = useSelector(selectShowUsedMargin)
	const showEquityMarginRatio = useSelector(selectShowEquityMarginRatio)
	const showBonusBalance = useSelector(selectShowBonusBalance)
	const showBalance = useSelector(selectShowBalance)
	// const userDailyClosedPnl = useSelector(selectUserDailyClosedPnl)

	const deposits = [
		{id: 'closedPnl', label: userClosedTotalPnl || 'Closed PNL', view: showClosedTotalPnl},
		{id: 'pnlTotal', label: userTotalPnl || 'PNL', view: showTotalPnl},
		{id: 'availableMargin', label: userAvailableMargin || 'Available margin', view: showAvailableMargin},
		{id: 'equity', label: userEquity || 'Equity', view: showEquity},
		{id: 'usedMargin', label: useMargin || 'Used margin', view: showUsedMargin},
		{id: 'marginRatio', label: deltaEquity || 'Margin ratio', view: showEquityMarginRatio},
		{id: 'cashBalance', label: userCashBalance || 'Cash balance', view: showCashBalance},
		{id: 'balance', label: userTotalBalance || 'Total Balance', view: showBalance},
		{id: 'bonusBalance', label: userBonusBalance || 'Bonus balance', view: showBonusBalance}
	].filter(d => d.view)



	return (
		<DepositBody deposits={deposits}>
			{deposits.map((deposit, index) => {
				if (!deposit.view) return
				return (
					deposit.id === 'marginRatio' ?
						<DepositItemMarginRatio key={deposit + index} sx deposit={deposit}/> :
						<DepositItem key={deposit + index} sx deposit={deposit}/>
				)
			})}
		</DepositBody>
	)
}



export default Deposits
